import { registerIcons, unregisterIcons } from '@uifabric/styling';

const embeddedFonts = {
  base: require('../node_modules/@uifabric/icons/fonts/fabric-icons-a13498cf.woff?inline'),
  1: require('../node_modules/@uifabric/icons/fonts/fabric-icons-1-360e3054.woff?inline'),
  2: require('../node_modules/@uifabric/icons/fonts/fabric-icons-2-8820ef0b.woff?inline'),
  3: require('../node_modules/@uifabric/icons/fonts/fabric-icons-3-7c253e01.woff?inline'),
  5: require('../node_modules/@uifabric/icons/fonts/fabric-icons-5-f6de453a.woff?inline'),
  7: require('../node_modules/@uifabric/icons/fonts/fabric-icons-7-bbebf62d.woff?inline'),
  8: require('../node_modules/@uifabric/icons/fonts/fabric-icons-8-50fd817c.woff?inline'),
  10: require('../node_modules/@uifabric/icons/fonts/fabric-icons-10-1ca3e4a1.woff?inline'),
  11: require('../node_modules/@uifabric/icons/fonts/fabric-icons-11-93bad8ee.woff?inline'),
  12: require('../node_modules/@uifabric/icons/fonts/fabric-icons-12-d9534567.woff?inline'),
  14: require('../node_modules/@uifabric/icons/fonts/fabric-icons-14-9a8324a9.woff?inline'),
};

const sharedStyle: any = {
  MozOsxFontSmoothing: 'grayscale',
  WebkitFontSmoothing: 'antialiased',
  fontStyle: 'normal',
  fontWeight: 'normal',
  speak: 'none',
};

const iconGroups = [
  {
    shard: 'base',
    icons: {
      ChevronDown: '\uE70D',
      Edit: '\uE70F',
      Add: '\uE710',
      Cancel: '\uE711',
      More: '\uE712',
      Settings: '\uE713',
      Mail: '\uE715',
      Filter: '\uE71C',
      Search: '\uE721',
      Share: '\uE72D',
      CheckMark: '\uE73E',
      Delete: '\uE74D',
      Calendar: '\uE787',
      Undo: '\uE7A7',
      Clear: '\uE894',
      Download: '\uE896',
      Upload: '\uE898',
      AlignLeft: '\uE8E4',
      Tag: '\uE8EC',
      Info: '\uE946',
      List: '\uEA37',
      CircleRing: '\uEA3A',
      Tiles: '\uECA5',
      Glimmer: '\uECF4',
      StatusCircleCheckmark: '\uF13E',
      MoreVertical: '\uF2BC',
    },
  },
  {
    shard: 1,
    icons: {
      Education: '\uE7BE',
      Home: '\uE80F',
      IncidentTriangle: '\uE814',
      RevToggleKey: '\uE845',
      Help: '\uE897',
      MailForward: '\uE89C',
      OpenInNewWindow: '\uE8A7',
      ViewAll: '\uE8A9',
      Switch: '\uE8AB',
      Rename: '\uE8AC',
      ChromeClose: '\uE8BB',
      Message: '\uE8BD',
      CalendarWeek: '\uE8C0',
      Copy: '\uE8C8',
      OpenFile: '\uE8E5',
    },
  },
  {
    shard: 2,
    icons: {
      RepeatAll: '\uE8EE',
      Chat: '\uE901',
      Group: '\uE902',
      Accounts: '\uE910',
      Clock: '\uE917',
      MiniExpand: '\uE93A',
    },
  },
  { shard: 3, icons: { Snow: '\uE9C8', CheckList: '\uE9D5' } },
  { shard: 5, icons: { CompletedSolid: '\uEC61', DateTime: '\uEC92' } },
  { shard: 7, icons: { PlayerSettings: '\uEF58' } },
  {
    shard: 8,
    icons: {
      Archive: '\uF03F',
      FabricOpenFolderHorizontal: '\uF0A8',
      ReadOutLoud: '\uF112',
    },
  },
  {
    shard: 10,
    icons: {
      BoxSubtractSolid: '\uF2D3',
      BoxAdditionSolid: '\uF2D4',
    },
  },
  { shard: 11, icons: { PageListSolid: '\uF33A' } },
  { shard: 12, icons: { Transition: '\uF3BC' } },
  { shard: 14, icons: { DrillDownSolid: '\uF533' } },
];

export function registerEmbeddedIcons() {
  const iconNames = iconGroups.reduce(
    (names, group) => names.concat(Object.keys(group.icons)),
    [] as string[]
  );

  unregisterIcons(iconNames);

  iconGroups.forEach(group => {
    registerIcons(
      {
        style: sharedStyle,
        fontFace: {
          fontFamily:
            group.shard === 'base'
              ? '"FabricMDL2Icons"'
              : `"FabricMDL2Icons-${group.shard}"`,
          src: `url('${embeddedFonts[group.shard]}') format('woff')`,
        },
        icons: group.icons,
      },
      { disableWarnings: true }
    );
  });
}
